import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Navbar from './Navbar';
import Landing from './Landing';
import About from './About';
import Categories from './Categories';
import Articles from './Articles';
import Footer from './Footer';
import '../../assets/css/style.css';
import Avatar from './Avatar';

const Home = (props) => {
    const aiDemo = props.hostname === "aidemo"


  return (
    <div>
        <div className='bg'>
          <Navbar user_id={props.user_id} setUserId={props.setUserId} navlinks={props.navlinks} hostname={props.hostname}/>
          <Landing user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname}/>
        </div>
          <About user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname}/>
          <Categories user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname}/>
          <Articles/>
          {aiDemo && (
                <Avatar user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname}/>
          )}
          <Footer user_id={props.user_id} setUserId={props.setUserId} hostname={props.hostname}/>
    </div>
  );
};

export default Home;